/*
 * fn: unslugify
 *
 * Attempts to unslugify a slug into a readable string
 *
 */
export const unslugify = (input: string) =>
  input
    .replace(/-/g, ' ')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
